import * as React from 'react';
import { graphql, PageProps } from 'gatsby';
import Layout from '../components/Layout';
import Content from '../components/Content';

interface DashboardIndexProps extends PageProps {
  data: {
    site: {
      siteMetadata: {
        title: string;
      };
    };
  };
}

function DashboardIndex({ data, location }: DashboardIndexProps): JSX.Element {
  const { title } = data.site.siteMetadata;
  return (
    <Layout location={location} title={title}>
      <Content />
    </Layout>
  );
}

export const pageQuery = graphql`
  query {
    site {
      siteMetadata {
        title
      }
    }
  }
`;
export default DashboardIndex;
